module.exports = __webpack_public_path__ + "images/emoji/chart.293e99ec1270b28a524f.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/chart.png
// module id = ieRM
// module chunks = 1